import { createApi } from '@reduxjs/toolkit/query/react'
import { MDT_STATUS_ADD, MDT_STATUS_DELETE, MDT_STATUS_EDIT, MDT_STATUS_LIST, MDT_STATUS_VIEW } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const mdtStatusApi = createApi({
    reducerPath: 'mdtStatusApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/mdt/status",
    }),
    tagTypes: ["mdtStatusList", "mdtStatusDetails"],
    endpoints: (builder) => ({

        // get mdt assessment list
        getMdtStatusList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: MDT_STATUS_LIST,
                data: { search, status, page, limit, sort }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["mdtStatusList"]
        }),

        // add new MDT status
        addMdtStatus: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MDT_STATUS_ADD,
                data
            }),
            invalidatesTags: ["mdtStatusList"]
        }),

        // update MDT status
        updateMdtStatus: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${MDT_STATUS_EDIT}/${id}`,
                data
            }),
            invalidatesTags: ["mdtStatusList"]
        }),

        // MDT status details
        mdtStatusDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MDT_STATUS_VIEW}/${id}`

            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["mdtStatusDetails"]
        }),

        // MDT status delete
        mdtStatusDelete: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MDT_STATUS_DELETE}/${id}`
            }),
            invalidatesTags: ["mdtStatusDetails", "mdtStatusList"]
        })
    }),
})

export const {
    useGetMdtStatusListQuery,
    useAddMdtStatusMutation,
    useUpdateMdtStatusMutation,
    useMdtStatusDetailsQuery,
    useMdtStatusDeleteMutation

} = mdtStatusApi;